import { UserRole, SubscriptionInfoModel } from "@jugl-web/rest-api";
import { SidebarItem } from "./types";

export const getAccessibleSidebarItems = (
  items: SidebarItem[],
  userRole: UserRole,
  subscriptionInfo: SubscriptionInfoModel
): SidebarItem[] =>
  items.reduce<SidebarItem[]>((accessibleItems, item) => {
    if (
      (item.requiredUserRoles && !item.requiredUserRoles.includes(userRole)) ||
      (item.requiredEnabledModules?.length &&
        item.requiredEnabledModules?.length !==
          subscriptionInfo.modules?.filter(
            ({ id, enabled }) =>
              item.requiredEnabledModules?.includes(id) &&
              (enabled || enabled === null)
          ).length)
    ) {
      return accessibleItems;
    }

    if (item.type === "accordion") {
      const accessibleAccordionItems = getAccessibleSidebarItems(
        item.items,
        userRole,
        subscriptionInfo
      );

      if (accessibleAccordionItems.length === 0) {
        return accessibleItems;
      }

      return [...accessibleItems, { ...item, items: accessibleAccordionItems }];
    }

    return [...accessibleItems, item];
  }, []);
